"use client";

import { useReportWebVitals } from "next/web-vitals";
import { logData } from "@jb-manage-trips/fe-logger";

export const WebVitals = () => {
  useReportWebVitals((metric: unknown) => {
    console.log(metric);

    void logData(
      {
        data: metric,
        type: "web-vitals",
      },
      "performance",
    );
  });

  return null;
};
